import { Text, TextColor, WeightType } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import styles from './premiumBadge.module.scss'

type PremiumBadgeProps = {
  title?: string
  titleWeight?: WeightType
  color?: TextColor
  shouldAnimate?: boolean
  fontSize?: string
  shouldHideBgColor?: boolean
}

const PremiumBadge: React.FC<PremiumBadgeProps> = props => {
  const {
    title,
    titleWeight = 'semiBold',
    fontSize = '11px',
    color = 'accent',
    shouldAnimate,
    shouldHideBgColor,
  } = props

  return (
    <div
      className={`${styles.wrapper} ${shouldHideBgColor ? styles.noBgColor : ''}`}
    >
      {shouldAnimate && (
        <>
          <div className={styles.flash} />
          <div className={`${styles.flash} ${styles.miniFlash}`} />
        </>
      )}
      <div className={styles.icon}>
        <Icon name="premium_crown" size={14} color="#fecd38" />
      </div>
      {title && (
        <Text
          type="footnote"
          content={title}
          style={{ fontSize: fontSize }}
          color={color}
          weight={titleWeight}
        />
      )}
    </div>
  )
}

export default PremiumBadge
